import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { GoogleLogin, GoogleOAuthProvider } from '@react-oauth/google';
import { jwtDecode } from 'jwt-decode';

const HomePage = () => {
    const navigate = useNavigate();
    const [userData, setUserData] = useState(null);
    // const [printHistory, setPrintHistory] = useState([]);
  
    useEffect(() => {
        // Get user data from localStorage
        const user = JSON.parse(localStorage.getItem('user'));
        if (user) {
            setUserData(user);
        }
        
        // Fetch print history from your backend
        // fetchPrintHistory(user.id);
    }, [ navigate ]);
    
    const handlePrint = () => {
        navigate('/print');
    };
    
    const [errorText, setErrorText] = React.useState('');

    const storeUserData = (userData) => {
        localStorage.setItem('user', JSON.stringify(userData));
        localStorage.setItem('isAuthenticated', 'true');
    };
        
    const handleSuccess = (credentialResponse) => {
        
        const decoded = jwtDecode(credentialResponse.credential);
        console.log(decoded);
        
        const userData = {
            name: decoded.name,
            email: decoded.email
        };
        storeUserData(userData);
        setUserData(userData);
        window.location.reload();
    };

    const handleError = () => {
        console.log('Login Failed');
        setErrorText('Login Failed');
    };

    return (
        <>
            {userData !== null ? (
                <div style={styles.home}>
                    <h2>Welcome, {userData?.name}!</h2>
                    <p>This is Pratt's new print form.</p>
                    <button style={styles.submitButton} onClick={handlePrint}>Submit a Print</button>
                </div>
            ) : (
                <div style={styles.home}>
                    <h2>Welcome!</h2>
                    <p>This is Pratt's new print form.</p>
                    <div style={styles.login}>
                        <h2>Login to continue: </h2>
                        <GoogleOAuthProvider clientId="82351172585-03kod231src5onh6h6ek7pl9s035aadp.apps.googleusercontent.com">
                            <GoogleLogin
                                onSuccess={handleSuccess}
                                onError={handleError}
                            />
                        </GoogleOAuthProvider>
                    </div>
                    <p style={{ color: 'red', }}>{errorText}</p>
                </div>
            )}
        </>
    )
}

const styles = {
    home: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    submitButton: {
        padding: 10,
        backgroundColor: '#FFB81C',
        color: 'white',
        borderRadius: 5,
        marginTop: 50,
        border: 'none',
        cursor: 'pointer',
        fontSize: 16,
    },
    login: {
        marginTop: 50,
        display: 'flex',
        flexDirection: 'row',
        gap: 10,
        alignItems: 'center',
    }
};

export default HomePage;